/**
 * Letter Selector Utility
 * Maps order IDs to approval/denial letter URLs for display
 */

const LETTER_URLS = {
  approved:
    "https://firebasestorage.googleapis.com/v0/b/prior--backen-prod-svc-u4g8.appspot.com/o/nch%2Fscreenshots%2FDemo%20Facility%2FGroup%204.jpg?alt=media&token=624e66eb-316e-4153-b8ce-2cdf15fba38e",
  denied:
    "https://firebasestorage.googleapis.com/v0/b/prior--backen-prod-svc-u4g8.appspot.com/o/nch%2Fscreenshots%2FDemo%20Facility%2FGroup%201000003221.png?alt=media&token=921357f8-862f-4e02-81e2-2f2accf4fae1",
};

// Mapping order IDs to letter types
const ORDER_LETTER_MAPPING: Record<string, "approved" | "denied"> = {
  "76e4eceb-d95c-44e2-9e71-663e92fdb540": "approved", // Tony Stark
  "ecc436f8-2050-4007-a3c2-e0beb3437217": "approved", // Selina Kyle
  "7d5b393e-83de-4380-b5e4-90c82acc4620": "denied", // Clark Kent
};

/**
 * Get the letter URL for a given order ID
 * @param orderId - The medical order ID
 * @returns The Firebase Storage URL for the approval or denial letter
 */
export const getLetterUrl = (orderId: string): string => {
  const letterType = ORDER_LETTER_MAPPING[orderId] || "approved";
  return LETTER_URLS[letterType];
};

/**
 * Get the letter title for display
 * @param orderId - The medical order ID
 * @returns "Approval Letter" or "Denial Letter"
 */
export const getLetterTitle = (orderId: string): string => {
  const letterType = ORDER_LETTER_MAPPING[orderId] || "approved";
  return letterType === "approved" ? "Approval Letter" : "Denial Letter";
};
